// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ji-0";
export var assigneeDetails = "_ji-1";
export var assigneeInfo = "_ji-2";
export var dropdownContainer = "_ji-4";
export var dropdownImage = "_ji-5";
export var editAssigneeInfo = "_ji-3";
export var editAssigneeModalContainer = "_ji-6";
export var hidden = "_ji-8";
export var input = "_ji-7";